import { Card, Dialog, styled } from "@mui/material";

export const InterviewDialogStyled = styled(Dialog)(({ theme }) => ({
    [theme.breakpoints.up('sm')]: {
        '& .MuiDialog-paper': {
            minWidth: '320px'
        },
    },
    [theme.breakpoints.up('md')]: {
        '& .MuiDialog-paper': {
            minWidth: '800px'
        },
    },
    [theme.breakpoints.up('lg')]: {
        '& .MuiDialog-paper': {
            minWidth: '900px'
        },
    },
    [theme.breakpoints.up('xl')]: {
        '& .MuiDialog-paper': {
            minWidth: '1000px'
        },
    },
    '& .MuiDialogTitle-root': {
        padding: `${theme.spacing(1)} ${theme.spacing(1.5)}`
    }
}));

export const InterviewCardStyled = styled(Card)(({ theme }) => ({
    [theme.breakpoints.up('sm')]: {
        '& .action-items': {
            opacity: 1
        }
    },
    [theme.breakpoints.up('md')]: {
        '& .action-items': {
            opacity: 0,
            transition: 'opacity 0.3s linear'
        },
        '&:hover': {
            '& .action-items': {
                opacity: 1
            }
        }
    },
    [theme.breakpoints.up('lg')]: {
        '& .action-items': {
            opacity: 0,
            transition: 'opacity 0.3s linear'
        },
        '&:hover': {
            '& .action-items': {
                opacity: 1
            }
        }
    },
    [theme.breakpoints.up('xl')]: {
        '& .action-items': {
            opacity: 0,
            transition: 'opacity 0.3s linear'
        },
        '&:hover': {
            '& .action-items': {
                opacity: 1
            }
        }
    },
    '& .MuiCardContent-root': {
        paddingBottom: theme.spacing(1)
    },
    '& .MuiCardActions-root': {
        paddingTop: 0
    }
}));